<div class="block_menu_desktop_designers block_menu_desktop_item d-flex justify-content-between" *ngIf="designers?.length > 0">
    <ul *ngFor="let designer of designers">
        <li><a
          [tawEventTracker]='{action: "taMenuDesigner_" + designer.Name, category: GoogleAnalyticEventCategory.taUserAction}'
           skipLocationChange [routerLink]="['/product-listing', { DesignerIds: designer.Name}]" (click)="onRouterClick()"><img class="Sirv" [attr.data-src]="designer.Title" alt="">{{designer.Name}} X</a></li>
    </ul>
</div>
